import React from "react";
import {
  Avatar,
  Box,
  ChevronUpDownIcon,
  MenuItem,
  Select,
  Stack,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicSelectWithAvatar = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Select with Avatar"}
        language={"js"}
        value={"<Select\n" +
            "          value={age}\n" +
            "          onChange={handleChange}\n" +
            "          IconComponent={ChevronUpDownIcon}\n" +
            "          width={200}\n" +
            "        >\n" +
            "          <MenuItem value={10}>\n" +
            "            <Stack direction={\"row\"} alignItems={\"center\"} spacing={1}>\n" +
            "              <Avatar size={\"small\"} />\n" +
            "              <span>Tom Cook - Default</span>\n" +
            "            </Stack>\n" +
            "          </MenuItem>\n" +
            "          <MenuItem value={20}>Twenty</MenuItem>\n" +
            "          <MenuItem value={30}>Thirty</MenuItem>\n" +
            "        </Select>\n" +
            "\n\n\n" +
            "        <Select\n" +
            "          value={age}\n" +
            "          onChange={handleChange}\n" +
            "          size=\"small\"\n" +
            "          IconComponent={ChevronUpDownIcon}\n" +
            "          width={200}\n" +
            "        >\n" +
            "          <MenuItem value={10}>\n" +
            "            <Stack direction={\"row\"} alignItems={\"center\"} spacing={1}>\n" +
            "              <Avatar size={\"small\"} />\n" +
            "              <span>Tom Cook - Small</span>\n" +
            "            </Stack>\n" +
            "          </MenuItem>\n" +
            "          <MenuItem value={20}>Twenty</MenuItem>\n" +
            "          <MenuItem value={30}>Thirty</MenuItem>\n" +
            "        </Select>"}
      >
        <Select
          value={age}
          onChange={handleChange}
          IconComponent={ChevronUpDownIcon}
          width={200}
        >
          <MenuItem value={10}>
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Avatar size={"small"} />
              <span>Tom Cook - Default</span>
            </Stack>
          </MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>

        <Select
          value={age}
          onChange={handleChange}
          size="small"
          IconComponent={ChevronUpDownIcon}
          width={200}
        >
          <MenuItem value={10}>
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Avatar size={"small"} />
              <span>Tom Cook - Small</span>
            </Stack>
          </MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectWithAvatar;
